import type { ReactNode } from "react";

/**
 * Shared UI primitives used by the four auth screens. Deliberately thin
 * — no design-system ambitions, just enough deduplication to keep the
 * button + spinner markup out of every screen.
 */

export function Spinner() {
    return <span className="spinner" aria-hidden="true" />;
}

export function SubmitButton({
    busy,
    disabled,
    label,
    busyLabel,
    children,
}: {
    busy: boolean;
    disabled?: boolean;
    label?: string;
    busyLabel?: string;
    children?: ReactNode;
}) {
    return (
        <button type="submit" className="button" disabled={busy || disabled}>
            {busy ? (
                <>
                    <Spinner />
                    {busyLabel ?? "Working…"}
                </>
            ) : (
                children ?? label
            )}
        </button>
    );
}
